import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    WebVisibilityEditorOptionsResponse,
    WebVisibilityRule
} from '@/interfaces/web-visibility-rule';
import { RatesVisibilitySyncStatus } from '@/interfaces/rates-visibility-sync-status';

@Injectable({
    providedIn: 'root'
})
export class WebVisibilityRulesService {

    constructor(private apiService: ApiService) {
    }

    list(): Observable<WebVisibilityRule[]> {
        return this.apiService.get<WebVisibilityRule[]>('/web-visibility-rules').pipe(
            map((res) => res.data ?? res as unknown as WebVisibilityRule[])
        );
    }

    editorOptions(): Observable<WebVisibilityEditorOptionsResponse> {
        return this.apiService.get<WebVisibilityEditorOptionsResponse>('/web-visibility-rules/editor-options').pipe(
            map((res) => res.data ?? res as unknown as WebVisibilityEditorOptionsResponse)
        );
    }

    bulkSave(rules: WebVisibilityRule[]): Observable<WebVisibilityRule[]> {
        return this.apiService.put<WebVisibilityRule[]>('/web-visibility-rules/bulk', { rules }).pipe(
            map((res) => res.data ?? res as unknown as WebVisibilityRule[])
        );
    }

    syncStatus(): Observable<RatesVisibilitySyncStatus | null> {
        return this.apiService.get<RatesVisibilitySyncStatus | null>('/web-visibility-rules/sync-status').pipe(
            map((res) => res.data ?? null)
        );
    }
}
